import {
  ClinicalNotesControllerApi,
  ClinicalNotesSaveRequest,
} from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

interface Params {
  clinicalNotesSaveRequest: ClinicalNotesSaveRequest;
}

/**
 * @author Rajkumar Rathod
 */
export const useAiScriberExportNote = () =>
  useMutationWithLoading(async (params: Params) => {
    const api = new ClinicalNotesControllerApi(getConfigObject());

    const response = api.saveClinicalNotes(
      params.clinicalNotesSaveRequest,
      getXtenantId()
    );

    return response;
  });
